import React from 'react';
import './Terms.css';

const TermsSE = () => {
  return (
    <div className="terms-page">
      <h1>Villkor och Bestämmelser</h1>
      <div className="terms-main">
        <p>
          Välkommen till Rewards &amp; Samples, LLC ("vi", "oss" eller "vår"). Genom att använda
          vår webbplats godkänner du följande villkor och bestämmelser.
        </p>

        <h3>1. ANVÄNDNINGSVILLKOR</h3>
        <p>
          Denna webbplats drivs av Rewards &amp; Samples, LLC. Genom att använda denna webbplats
          accepterar du att vara bunden av dessa användningsvillkor, alla tillämpliga lagar och
          förordningar.
        </p>

        <h3>2. BEHÖRIGHET</h3>
        <p>För att delta i vårt belöningsprogram måste du:</p>
        <ul>
          <li>Vara minst 18 år gammal</li>
          <li>Ha laglig hemvist i Sverige</li>
          <li>Ange en giltig e-postadress</li>
          <li>Fylla i all nödvändig registreringsinformation sanningsenligt</li>
        </ul>

        <h3>3. BELÖNINGSPROGRAM</h3>
        <p>
          Vårt belöningsprogram låter dig tjäna belöningar genom att slutföra sponsrade erbjudanden.
          Antalet erbjudanden som krävs och belöningens värde varierar beroende på programmet.
        </p>
        <ul>
          <li>Du måste slutföra det nödvändiga antalet sponsrade erbjudanden</li>
          <li>Erbjudanden måste slutföras inom den angivna tidsperioden</li>
          <li>ID-verifiering krävs för att ta emot belöningar</li>
          <li>Bearbetning av belöningar kan ta 5–7 arbetsdagar</li>
        </ul>

        <h3>4. FRISKRIVNING</h3>
        <p>
          Varumärken och handelsnamn som nämns på denna webbplats tillhör respektive ägare och är
          inte anslutna till denna kampanj. Vi ansvarar inte för tredjepartstjänster eller produkter.
        </p>

        <h3>5. ÄNDRINGAR AV VILLKOR</h3>
        <p>
          Vi förbehåller oss rätten att ändra dessa villkor när som helst. Ändringar publiceras på
          denna sida och träder i kraft omedelbart efter publicering.
        </p>

        <h3>6. IMMATERIELLA RÄTTIGHETER</h3>
        <p>
          Allt innehåll på denna webbplats, inklusive text, grafik, logotyper och programvara,
          tillhör Rewards &amp; Samples, LLC eller dess licensgivare och skyddas av upphovsrättslagar.
        </p>

        <h3>7. ANSVARSBEGRÄNSNING</h3>
        <p>
          Vi ansvarar inte för direkta, indirekta, oavsiktliga, speciella eller följdskador som
          uppstår vid användning av eller oförmåga att använda denna webbplats.
        </p>

        <h3>8. TILLÄMPLIG LAG</h3>
        <p>
          Dessa villkor regleras av och tolkas i enlighet med svensk lagstiftning. Alla tvister
          ska lösas i svenska domstolar.
        </p>

        <h3>9. KONTAKT</h3>
        <p>Om du har frågor om dessa villkor, vänligen kontakta oss.</p>

        <div className="last-updated">Senast uppdaterad: Januari 2026</div>
      </div>
    </div>
  );
};

export default TermsSE;
